import { Button, Paper } from '@mui/material'
import cx from 'classnames'
import moment from 'moment'
import React from 'react'
import { useForm } from 'react-hook-form'
import FormField from '../../../common/form/FormField'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import { i18n } from '../../index'
import css from './marketSettingsPage.css'
import { ChainMarketSettingsInputForm, MarketSettings } from './types'

interface Props {
  marketSettings: MarketSettings[]
  updateChainMarketSettingsMutation: any
  deleteChainMarketSettingsMutation: any
}

export default function ChainMarketSettingsList({
  marketSettings,
  updateChainMarketSettingsMutation,
  deleteChainMarketSettingsMutation,
}: Props) {
  return (
    <Paper>
      {marketSettings.map((marketSetting) => (
        <UpdateVolumeTargetSettingsForm
          key={marketSetting.id}
          marketSetting={marketSetting}
          updateChainMarketSettingsMutation={updateChainMarketSettingsMutation}
          deleteChainMarketSettingsMutation={deleteChainMarketSettingsMutation}
        />
      ))}
    </Paper>
  )
}

const getYear = (setting: MarketSettings) => {
  return moment(setting.startDate).format('YYYY')
}

function UpdateVolumeTargetSettingsForm({
  marketSetting,
  updateChainMarketSettingsMutation,
  deleteChainMarketSettingsMutation,
}: {
  marketSetting: MarketSettings
  updateChainMarketSettingsMutation: any
  deleteChainMarketSettingsMutation: any
}) {
  const { control, handleSubmit } = useForm<ChainMarketSettingsInputForm>({
    defaultValues: {
      value: marketSetting.value,
      name: marketSetting.name,
      year: getYear(marketSetting),
    },
  })

  const [edit, setEdit] = React.useState(false)

  const toggleEdit = () => {
    setEdit(!edit)
  }

  const onSubmit = handleSubmit(async (data: ChainMarketSettingsInputForm) => {
    updateChainMarketSettingsMutation({
      variables: {
        id: marketSetting.id,
        data: {
          name: 'MARKET_SALES_VOLUME_TARGET',
          value: data.value,
          startDate: moment(data.year).startOf('year').toISOString(),
          endDate: moment(data.year).endOf('year').toISOString(),
        },
      },
    })
    toggleEdit()
  })

  const onDelete = () => {
    deleteChainMarketSettingsMutation({
      variables: {
        id: marketSetting.id,
      },
    })
  }

  if (edit) {
    return (
      <form onSubmit={onSubmit}>
        <div className={css.inlineForm}>
          <FormField
            label={i18n.t('admin.marketSettings.target')}
            control={control}
            variant='outlined'
            name='value'
            type='number'
            rules={{ required: true }}
          />
          <FormField
            label={i18n.t('admin.marketSettings.year')}
            control={control}
            variant='outlined'
            name='year'
            type='number'
            rules={{ required: true }}
          />
          <div className={cx(css.right, css.inlineForm)}>
            <Button color='primary' variant='contained' type='submit' size='medium'>
              {i18n.t('buttons.save')}
            </Button>
            <Button color='secondary' variant='contained' size='medium' onClick={toggleEdit}>
              {i18n.t('buttons.cancel')}
            </Button>
          </div>
        </div>
      </form>
    )
  }
  return (
    <div className={css.inlineForm}>
      {i18n.t('admin.marketSettings.target')} : {marketSetting.value} {i18n.t('admin.marketSettings.year')}{' '}
      {getYear(marketSetting)}
      <Button className={css.right} variant='contained' size='medium' onClick={toggleEdit}>
        {i18n.t('buttons.edit')}
      </Button>
      <DeleteButton onClick={onDelete} />
    </div>
  )
}
